import IntegrationTableIvy from "../../../features/plugins/integrations/components/IntegrationTable/IntegrationTableIvy";
import IntegrationTableWorksheet from "../../../features/plugins/integrations/components/IntegrationTable/IntegrationTableWorksheet";
import SliderTab from '/src/components/slider/sliderTab';
import { PageTable, Header } from '/src/layouts/page';

function IntegrationList() {
    const items = [
        { name: 'Ivy', component: <IntegrationTableIvy /> },
        { name: 'Worksheet', component: <IntegrationTableWorksheet /> },
    ]


    return (
        <PageTable>
            
            <Header title="API Key Manager"></Header>
            <SliderTab items={items} name="datasets"></SliderTab>
        </PageTable>
    )
}

export default IntegrationList;